import React from 'react'
import ExpandablePanel from '../../components/controls/ExpandablePanel'
import TextField from '@material-ui/core/TextField'
import { controlHasError } from '../../lib/errorHandler'
import PrintText from '../../lib/PrintText'

export default function MetodyWyceny(props) {
  return (
    <ExpandablePanel title="METODY WYCENY AKTYWÓW I PASYWÓW (TAKŻE AMORTYZACJI)">
      <form autoComplete="off" className="subsection">
        {props.czyPodsumowanie ? (
          <PrintText
            text={props.data.MetodyWyceny}
          />
        ) : (
          <TextField
            error={controlHasError(
              props.errors,
              'MetodyWyceny',
              props.data.MetodyWyceny,
            )}
            name="MetodyWyceny"
            label="Opis"
            multiline
            variant="outlined"
            title={props.data.MetodyWyceny}
            defaultValue={props.data.MetodyWyceny}
            onBlur={(e) =>
              props.onSetSectionData('MetodyWyceny', e.target.value)
            }
          />
        )}
      </form>
    </ExpandablePanel>
  )
}
